import { convertGrantedContentsToRewardItems } from '~/features/reward-flow/helper'
import { useGatedMutation } from '~/lib/gated-mutation'
import { contentTitleQueryOptions } from '~/hooks/use-content-title'
import { queryClient } from '~/lib/query-client'
import { openMutationErrorDialog } from '~/lib/mutation-error-dialog'
import { claimReward } from '~/services/api/gamepass-service'
import { logNonFatalError } from '~/lib/log-errors'

export function useClaimRewardMutation() {
  return useGatedMutation({
    mutationFn: async ({
      activityId,
      stepId,
    }: {
      activityId: number
      stepId: number
    }) => {
      const response = await claimReward(activityId, stepId)
      const items = await convertGrantedContentsToRewardItems(
        response.granted_contents,
        (key) => queryClient.fetchQuery(contentTitleQueryOptions(key)),
      )
      return { response, items }
    },

    onError: (error) => {
      logNonFatalError({
        name: 'failed_to_claim_reward',
        code: 1,
        params: {
          message: String(error),
        },
      })

      openMutationErrorDialog(error)
    },
  })
}
